/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetComponentKbTypeResponseDto
 */
export interface AssetComponentKbTypeResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AssetComponentKbTypeResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetComponentKbTypeResponseDto
     */
    name: string;
}

/**
 * Check if a given object implements the AssetComponentKbTypeResponseDto interface.
 */
export function instanceOfAssetComponentKbTypeResponseDto(value: object): value is AssetComponentKbTypeResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function AssetComponentKbTypeResponseDtoFromJSON(json: any): AssetComponentKbTypeResponseDto {
    return AssetComponentKbTypeResponseDtoFromJSONTyped(json, false);
}

export function AssetComponentKbTypeResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetComponentKbTypeResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function AssetComponentKbTypeResponseDtoToJSON(json: any): AssetComponentKbTypeResponseDto {
    return AssetComponentKbTypeResponseDtoToJSONTyped(json, false);
}

export function AssetComponentKbTypeResponseDtoToJSONTyped(value?: AssetComponentKbTypeResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

